import { Link } from "react-router-dom";
import DashboardSidebar from "../../components/dashboardSidebar";
import AuthPage from "../../components/layout/authPage";
import StickyBox from "react-sticky-box";
import React, { JSX, useState } from "react";
import { Col, Row, Text } from "../../style/base.style";
import { doctordashboardprofile06, doctordashboardprofile07, doctordashboardprofile08 } from "../../constants/images";
import { useDictionary } from "../../contexts/dictionary";
import { useContactType } from "../../contexts/ContactContext";
import { useFormHandling } from "../../hooks/formUtils";
import { RequestConfigs } from "../../api";
import { ProfileImg } from "../common/profileImage";
import { useDeviceType } from "../../contexts/DeviceContext";


interface DashboardProps {
     children?: React.ReactNode;
     title: string;
}


export const DashboardPage: React.FC<DashboardProps> = ({children,title}:DashboardProps) => {
    const {translate} = useDictionary();
    const {family,contact} = useContactType();
    const {isMobile} = useDeviceType();
    const {handleClick} = useFormHandling({requestType:RequestConfigs.switchMember});

    const switchMember = (member:FamilyMember)=>{

        handleClick({id:member.id});
    }
    console.log('family!',family)
    return (
        <AuthPage>
            <Col $width={isMobile?"100%":"90%"}>
            
                <div className="container">
                    <div className="row">
                        <div className="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                            {
                                !isMobile && 
                                <StickyBox offsetTop={20} offsetBottom={20}>
                                    <DashboardSidebar/>
                                </StickyBox>

                            }
                            
                        </div>
                        {/* Render the selected Page component */}
                       <Col $width={isMobile?"100%":"70%"} $justifyContent="flex-start" className="content-dash">
                       <Row $width="100%" $alignItems="flex-start">
                       <div className="dashboard-header" style={{width:'100%'}}>
                            <h3>{translate(title)}</h3>
                           {
                            family && family.length > 0 && (
                                <ul className='header-list-btns'>
                                <li>
                                <div className="dropdown header-dropdown">
                                    <Link
                                    className="dropdown-toggle"
                                    data-bs-toggle="dropdown"
                                    to="#"
                                    >
                                    <ProfileImg width={20} height={20}/>
                                    {contact?.Full_Name}
                                    </Link>
                                    <div className="dropdown-menu dropdown-menu-end">
                                        {
                                            family.map((member,index)=>(
                                                <Link to="#" className="dropdown-item" key={index} onClick={()=>switchMember(member)}>
                                                    <Row $width="100%" $justifyContent="flex-start" $gap={5} $alignItems="center">
                                                    <ProfileImg width={20} height={20} contact={member}/>
                                                    {member.Full_Name}
                                                    </Row>
                                                      
                                                </Link>
                                            ))
                                        }
                                   
                                    </div>
                                </div>
                                </li>
                            </ul>
                            )
                           }
                                        </div>
                       </Row>
                       
                           {children}
                        
                        </Col>
                    </div>
                </div>
                </Col>
          
        </AuthPage>
    );
};
